import PropTypes from 'prop-types'
import Tooltip from 'components/tooltip/Tooltip'

import { shallowEqual, useSelector } from 'react-redux'
import { KeywordExtensionTypes } from './adGroupKeywordExtensionEditSlice'

const ExceptionKeywordsTooltip = ({ exceptionKeywords }) => {
  const { type } = useSelector(
    ({ dashboard }) => dashboard.operation.adGroupKeywordExtensionEdit,
    shallowEqual
  )
  const { length } = exceptionKeywords
  const keywords = exceptionKeywords.join(', ')
  return (
    <Tooltip
      position="top center"
      nowrap={false}
      className="tooltip_basic ly_tooltip ly_preview"
      content={
        <>
          <strong className="tit_tooltip">
            {type === KeywordExtensionTypes.keywordEx ? '키워드 확장 ' : ''}제외
            키워드 ({length})
          </strong>
          <p className="txt_tooltip2">{keywords}</p>
        </>
      }>
      설정
    </Tooltip>
  )
}
ExceptionKeywordsTooltip.propTypes = {
  exceptionKeywords: PropTypes.array.isRequired,
}
export default ExceptionKeywordsTooltip
